import { ALL_UUID } from '@/shared/constants';
import { GridColumnSettings } from '@/shared/types/grid';

export const numberColumn = <T>(options: {
  uid?: string;
  field: keyof T & string;
  header: string;
  linkUrl?: string;
  positiveClass?: string;
  positiveSuffix?: string;
  zeroClass?: string;
  zeroText?: string;
  emptyText?: string;
  emptyClass?: string;
  allowFiltering?: boolean;
  allowSorting?: boolean;
  width?: number;
  visible?: boolean;
  chooserName?: string;
}): GridColumnSettings<T> => {
  const {
    uid,
    field,
    header,
    linkUrl,
    positiveClass,
    positiveSuffix,
    zeroClass = 'text-more-muted',
    zeroText = '',
    allowFiltering,
    allowSorting,
    width,
    visible,
    chooserName,
  } = options ?? {};

  let classTemplate: string | undefined;

  if (positiveClass || zeroClass) {
    classTemplate = `\${if(${field})}${positiveClass}\${else}\${if(${field} === 0)}${zeroClass}\${/if}\${/if}`;
  }

  const valueTemplate = positiveSuffix
    ? `\${if(${field} > 0)}\${${field}}${positiveSuffix}\${else}<span class="${zeroClass}">${zeroText}</span>\${/if}`
    : `\${if(${field} === 0 || ${field})}\${${field}}\${/if}`;

  let template: string | undefined;

  if (linkUrl) {
    template = `<a href="${linkUrl.replace('{id}', `\${if(id === '${ALL_UUID}')}isnull\${else}\${id}\${/if}`)}"${
      classTemplate ? ` class="${classTemplate}"` : ''
    }>${valueTemplate}</a>`;
  } else if (classTemplate) {
    template = `<span class="${classTemplate}">${valueTemplate}</span>`;
  }

  return {
    uid: uid ?? field,
    field,
    headerText: header,
    type: 'number',
    template,
    allowFiltering: allowFiltering ?? true,
    allowSorting: allowSorting ?? true,
    width: width ?? 120,
    visible: visible ?? true,
    chooserName,
  };
};
